import React from "react";
import {AuthPiece} from "aws-amplify-react";
import {Auth} from "aws-amplify";
import SimpleReactValidator from 'simple-react-validator';
import {ChangeEmailComponents} from "../Components/ChangeEmailComponents";
import {err_logger} from "../Logics/logger";

export default class ChangeEmail extends AuthPiece  {
    constructor(props) {
        super(props);
        this.state = {
            email: "" ,
            email_confirm: ""
        };
        this._validAuthStates = ['ChangeEmail'];
        this.updateEmail = this.updateEmail.bind(this);
        this.handleInputChangeCustom = this.handleInputChangeCustom.bind(this);
        this.validator = new SimpleReactValidator(
            {
                className: 'text-danger',
                messages: {
                    required: "入力必須項目です",
                    email: 'メール形式で入力してください'
                },
                validators: {
                     email_confirm: {
                         message: '確認用メールアドレスが一致しません。',
                         rule: (val, params, validator) => {
                             if (val.email !== val.email_confirm) return false
                             else return true;
                         }
                     }
                 }
            }
        );
    }
    validate() {
        let err  = false;
        if (!this.validator.allValid()) {
            this.validator.showMessages();
            err  = true;
            this.forceUpdate();
        }
        return err;
    }
    async updateEmail() {
        const err = this.validate();
        if (err) {
            return;
        }
        let user = await Auth.currentAuthenticatedUser();
        const email = this.state.email.toLowerCase();

        if (user.attributes.email === email) {
            this.error("登録されたメールアドレスと同じメールアドレスで更新出来ません");
            return;
        }
        try {
            let result = await Auth.updateUserAttributes(user, {email});
            if (result === "SUCCESS") {
                window.history.replaceState('','','/confirm_change_email');
                this.changeState('ConfirmChangeEmail',{user, email, isSendChangeEmail: true});
            } else {
                this.error("メールアドレスの更新に失敗しました");
            }
        } catch  (err) {
            err_logger(email , err, "updateUserAttributes of email",{email});
            this.error("メールアドレスの更新に失敗しました");
        }

    }
    handleInputChangeCustom(e) {
        this.setState({
            [e.target.name] : e.target.value
        });
    }
    showComponent(theme) {
        return (
            <ChangeEmailComponents theme={theme} handleInputChangeCustom={this.handleInputChangeCustom}
                                   email_err_msg={this.validator.message("email", this.state.email, 'required|email')}
                                   email_confirm_err_msg={this.validator.message("email_confirm", {email: this.state.email, email_confirm: this.state.email_confirm }, 'email_confirm')}
                                   updateEmail={this.updateEmail} history_back={() => {
                window.history.back(-1);
                return false;
            }}/>
        )
    }
}